import React, { MouseEventHandler } from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.svg<{ hasClickHandler: boolean; disabled: boolean }>`
  width: var(--icon-size);
  height: var(--icon-size);
  cursor: ${({ hasClickHandler }) => (hasClickHandler ? "pointer" : "default")};
  pointer-events: ${({ hasClickHandler }) =>
    hasClickHandler ? "auto" : "none"};
  fill: ${({ disabled }) => (disabled ? "var(--light-gray)" : "inherit")};
  overflow: visible;
`;

interface Props {
  className?: string;
  onClick?: MouseEventHandler<SVGSVGElement>;
  disabled?: boolean;
  fill?: string;
  style?: React.CSSProperties;
}

export const CloseIcon: React.FC<Props> = ({
  className,
  onClick,
  disabled,
  fill,
  style,
}) => {
  return (
    <StyledRoot
      hasClickHandler={!!onClick}
      disabled={!!disabled}
      onClick={onClick}
      className={className}
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill={fill ?? "var(--dark-gray)"}
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      ></path>
    </StyledRoot>
  );
};
